{
  "common": {
    "appName": "Qahvadosh Admin",
    "loading": "Загрузка…",
    "save": "Сохранить",
    "cancel": "Отмена",
    "close": "Закрыть",
    "apply": "Применить",
    "reset": "Сбросить",
    "search": "Поиск",
    "filter": "Фильтр",
    "actions": "Действия",
    "details": "Подробнее",
    "confirm": "Подтвердить",
    "yes": "Да",
    "no": "Нет",
    "all": "Все",
    "from": "с",
    "to": "по",
    "sum": "сум",
    "coffee": "кофе",
    "coffeeCount": "{{count}} кофе",
    "theme": "Оформление",
    "themeLight": "Светлая",
    "themeDark": "Тёмная",
    "themeSystem": "Системная",
    "language": "Язык",
    "logout": "Выйти",
    "copy": "Копировать",
    "copied": "Скопировано",
    "never": "Никогда",
    "today": "Сегодня",
    "week": "Неделя",
    "month": "Месяц",
    "quarter": "Квартал",
    "minutesShort": "{{count}} мин",
    "duration": "Длительность",
    "edit": "Редактировать",
    "delete": "Удалить",
    "logoutTitle": "Выйти?",
    "logoutBody": "Сессия закроется, и вы вернётесь на сайт. Для возврата в панель нужно будет войти снова.",
    "back": "Назад",
    "day": "День",
    "year": "Год"
  },
  "nav": {
    "dashboard": "Статистика",
    "analytics": "Аналитика",
    "users": "Пользователи",
    "invitations": "Приглашения",
    "ledger": "Учёт (ledger)",
    "payments": "Платежи",
    "withdrawals": "Выводы",
    "reports": "Жалобы",
    "hostApplications": "Заявки наставников",
    "settings": "Настройки",
    "openMenu": "Открыть меню",
    "roles": "Роли",
    "reference": "Справочники",
    "referenceIndustries": "Сферы",
    "referenceRegions": "Области",
    "referenceDistricts": "Районы",
    "finance": "Деньги",
    "settingsPlatform": "Платформа",
    "settingsMeetings": "Встречи",
    "audit": "Журнал действий",
    "promo": "Промокоды",
    "payouts": "Налоговые профили",
    "live": "Эфиры",
    "reviews": "Отзывы",
    "messages": "Сообщения"
  },
  "auth": {
    "checking": "Проверяем сессию…",
    "signInRequired": "Требуется вход",
    "signInHint": "Чтобы войти в админ-панель, авторизуйтесь через Telegram на основном сайте. Сессия действует на обоих сайтах.",
    "goToLogin": "На страницу входа",
    "stepOne": "Войдите через Telegram на основном сайте",
    "stepTwo": "После подтверждения вернитесь на эту страницу",
    "stepThree": "Панель откроется автоматически",
    "sessionNote": "Без пароля: сессия хранится в защищённой cookie и действует на обоих сайтах.",
    "backToSite": "Вернуться на сайт",
    "networkHint": "Сервер не отвечает. Проверьте соединение и попробуйте снова.",
    "retry": "Повторить",
    "forbiddenTitle": "Нет доступа",
    "forbiddenHint": "У вас нет прав на этот раздел. Если нужно — попросите у владельца системы подходящую роль.",
    "role": "Роль",
    "superadmin": "Суперадмин",
    "permissionCount": "{{count}} прав"
  },
  "dashboard": {
    "title": "Статистика",
    "subtitle": "Подтверждённые встречи — главный показатель. Не число регистраций.",
    "period": "Период",
    "confirmedMeetings": "Подтверждённые встречи",
    "activeHosts": "Активные наставники",
    "acceptRate": "Приглашение → принятие",
    "confirmRate": "Принятие → подтверждение",
    "medianResponse": "Время ответа (медиана)",
    "repeatGuests": "Повторные гости",
    "internalCirculation": "Внутренний оборот",
    "disputeRate": "Уровень споров",
    "revenue": "Доход платформы",
    "target": "Цель: {{value}}",
    "hours": "{{count}} ч",
    "funnelTitle": "Воронка",
    "funnelSignup": "Зарегистрировался",
    "funnelProfile": "Заполнил профиль",
    "funnelSearch": "Искал",
    "funnelInvited": "Отправил приглашение",
    "funnelAccepted": "Принято",
    "funnelConfirmed": "Подтверждено",
    "meetingsChart": "Встречи по неделям",
    "statusChart": "Приглашения по статусам",
    "empty": "Нет данных за этот период",
    "rangeHint": "{{from}} — {{to}}. Сравнение: {{comparedFrom}} — {{comparedTo}}.",
    "previousWas": "В прошлом периоде: {{value}}",
    "sectionCore": "Ключевые показатели",
    "sectionUsers": "Пользователи",
    "sectionMoney": "Кофе и деньги",
    "invitationsSent": "Отправлено приглашений",
    "accepted": "Принято",
    "ofHosts": "Из {{value}} наставников",
    "newUsers": "Новые пользователи",
    "totalUsers": "Всего пользователей",
    "activeUsers": "Активны за период: {{value}}",
    "hosts": "Наставники",
    "newHosts": "Новых за период: {{value}}",
    "blockedUsers": "Заблокированы",
    "deletedUsers": "Удалены: {{value}}",
    "payments": "Платежи",
    "payouts": "Выплаты",
    "paymentCount": "{{count}} платежей · продано {{coffees}}",
    "pendingPayout": "Ожидает: {{value}}",
    "liability": "Резерв на возвраты",
    "liabilityHint": "Неизрасходованный кофе по цене {{price}} — верхняя граница",
    "revenueHint": "Сами продажи — деньги никуда не возвращаются",
    "coffeesPurchased": "Куплено кофе",
    "coffeesWithdrawn": "Выведено кофе",
    "spentOnMeetings": "На встречи: {{value}}",
    "circulating": "Кофе в обороте",
    "circulatingHint": "Заблокировано {{held}}, созревает {{maturing}}",
    "avgRating": "Средняя оценка",
    "reviewCount": "{{count}} оценок",
    "meetingsCount": "{{count}} встреч",
    "minutes": "{{count}} минут",
    "queueTitle": "Требует внимания",
    "queueEmpty": "Очередь пуста — ничего не ждёт.",
    "oldest": "самое старое {{value}}",
    "queue": {
      "negativeBalances": "Пользователи с отрицательным балансом",
      "openDisputes": "Открытые споры",
      "pendingWithdrawals": "Невыплаченные заявки на вывод",
      "stuckPayments": "Зависшие платежи",
      "expiringSoon": "Приглашения с истекающим сроком",
      "pendingInvitations": "Приглашения без ответа",
      "blockedUsers": "Заблокированные пользователи",
      "unverifiedHosts": "Неподтверждённые наставники"
    },
    "moneyChart": "Движение денег",
    "topHosts": "Самые активные наставники",
    "topGuests": "Самые активные гости",
    "topRated": "По рейтингу",
    "notEnoughRatings": "Пока недостаточно оценок",
    "providersTitle": "Платёжные провайдеры",
    "formatsTitle": "Формат и длительность",
    "regionsTitle": "Регионы",
    "industriesTitle": "Отрасли",
    "providers": {
      "payme": "Payme",
      "click": "Click"
    },
    "formats": {
      "offline": "Очно",
      "online": "Онлайн"
    },
    "withdrawalCount": "{{count}} выводов · выведено {{coffees}}",
    "sectionQueueHint": "Работа, которая ждёт. Каждая строка ведёт на нужную страницу.",
    "sectionSummary": "Итоги периода",
    "sectionSummaryHint": "Выбранный период в сравнении с предыдущим.",
    "sectionTrends": "Динамика",
    "sectionTrendsHint": "Как менялись показатели внутри периода.",
    "sectionFunnelHint": "От регистрации до подтверждённой встречи: где теряем.",
    "sectionBreakdown": "Разрезы",
    "sectionBreakdownHint": "За счёт чего складываются приглашения, платежи и встречи.",
    "sectionTop": "Лидеры",
    "sectionTopHint": "Самые активные хосты и гости за период, рейтинг — за всё время.",
    "noAccess": "Здесь нечего показать",
    "noAccessHint": "У вас нет доступа ни к одному блоку панели. Запросите нужный раздел у администратора."
  },
  "users": {
    "title": "Пользователи",
    "subtitle": "Поиск, блокировка и назначение ролей.",
    "name": "Имя",
    "telegram": "Telegram",
    "phone": "Телефон",
    "status": "Статус",
    "balance": "Баланс",
    "meetings": "Встречи",
    "registered": "Регистрация",
    "hostMode": "Наставник",
    "verified": "Подтверждён",
    "block": "Заблокировать",
    "unblock": "Разблокировать",
    "blockTitle": "Блокировка пользователя",
    "blockReason": "Причина",
    "blockHint": "Заблокированный пользователь не сможет войти, его приглашения отменяются. Заблокированный кофе возвращается гостю.",
    "roles": "Роли",
    "statuses": {
      "active": "Активен",
      "blocked": "Заблокирован",
      "deleted": "Удалён"
    },
    "blockReasons": {
      "negative_balance": "Отрицательный баланс",
      "abuse": "Нарушение правил",
      "fraud": "Мошенничество",
      "admin_decision": "Решение администратора"
    },
    "empty": "Пользователи не найдены",
    "manageRoles": "Роли",
    "lastSeen": "Последняя активность",
    "loadFailed": "Список не загрузился",
    "loadFailedHint": "Сервер не ответил. Обновите страницу или попробуйте позже.",
    "emptyHint": "Попробуйте сбросить фильтры — подходящих пользователей нет.",
    "superadmin": "Суперадмин",
    "noRoles": "Роли не назначены",
    "profile": "Профиль",
    "finance": "Финансы",
    "financeForbidden": "Нет доступа к финансовым данным (ledger.read).",
    "notFound": "Пользователь не найден",
    "availableBalance": "Доступно кофе",
    "heldAndMaturing": "Заблокировано: {{held}} · Созревает: {{maturing}}",
    "coffeesBought": "Куплено кофе",
    "withdrawn": "Выведено",
    "coffeesEarned": "Со встреч",
    "coffeesSpent": "На встречи",
    "meetingsAsHost": "{{count}} встреч как наставник",
    "meetingsAsGuest": "{{count}} встреч как гость",
    "net": "Чистое движение",
    "netHint": "Приход (куплено + заработано) минус расход (потрачено + выведено).",
    "spentUzs": "оплачено {{amount}} сум",
    "receivedUzs": "получено {{amount}} сум",
    "asHost": "Как наставник",
    "asGuest": "Как гость",
    "delete": "Удалить",
    "deleted": "Аккаунт удалён",
    "confirmDelete": "Аккаунт будет помечен как удалённый, режим наставника отключится. Записи из базы не удаляются — история расчётов сохраняется. Отменить нельзя: разблокировка не восстанавливает удалённый аккаунт.",
    "expiresAt": "Действует до {{date}}",
    "blockDuration": "Срок",
    "blockForever": "Навсегда",
    "blockDays": "{{count}} дн.",
    "blockUntil": "До {{date}}",
    "blockDurationHint": "Срочная блокировка снимается сама. За первое нарушение обычно достаточно недели."
  },
  "invitations": {
    "title": "Приглашения",
    "subtitle": "От кого кому, когда отправлено, ответили ли и почему.",
    "guest": "Гость",
    "host": "Наставник",
    "topic": "Тема",
    "coffees": "Кофе",
    "status": "Статус",
    "created": "Создано",
    "expires": "Истекает",
    "empty": "Приглашения не найдены",
    "statuses": {
      "pending": "Ожидает ответа",
      "accepted": "Принято",
      "declined": "Отклонено",
      "slot_taken": "Время занято",
      "expired": "Истекло",
      "cancelled_by_guest": "Отменено гостем",
      "cancelled_by_host": "Отменено наставником",
      "cancelled_by_admin": "Отменено модератором",
      "confirmed": "Подтверждено",
      "disputed": "Спор",
      "refunded": "Возвращено",
      "no_show": "Не пришли",
      "settled": "Распределено"
    },
    "refund": "Ручной возврат",
    "refundTitle": "Возврат кофе",
    "refundHint": "Кофе вернётся гостю и в ledger появится запись. Это действие необратимо.",
    "refundAmount": "Сумма возврата",
    "duration": "Длительность",
    "when": "Время встречи",
    "search": "Имя или Telegram",
    "sentAt": "Отправлено",
    "answeredAt": "Ответ",
    "declineReason": "Причина",
    "price": "Сумма",
    "noAnswer": "Без ответа",
    "emptyHint": "Расширьте фильтр или выберите другой период.",
    "loadFailed": "Не удалось загрузить приглашения",
    "loadFailedHint": "Сервер не ответил. Попробуйте обновить страницу.",
    "format": "Формат",
    "formats": {
      "online": "Онлайн",
      "offline": "Вживую"
    },
    "detailTitle": "Карточка встречи",
    "detailSubtitle": "Само приглашение, журнал комнаты и участие — на одной странице.",
    "notFound": "Приглашение не найдено",
    "notFoundHint": "Ссылка устарела или приглашение удалено. Вернитесь к списку и поищите там.",
    "open": "Открыть",
    "sectionInvitation": "Приглашение",
    "sectionRoom": "Онлайн-комната",
    "roomOfflineHint": "Встреча была очной: онлайн-комната не открывалась, поэтому и журнала нет.",
    "cancel": "Отменить приглашение",
    "cancelHint": "Кофе вернётся гостю полностью. Компенсация за позднюю отмену не удерживается — гость ничего не сделал.",
    "cancelConfirm": "Приглашение будет закрыто, кофе вернётся гостю полностью. Отменить это действие нельзя.",
    "cancelReason": "Причина",
    "cancelReasonPlaceholder": "Например: наставник заблокирован, встреча не состоится",
    "cancelReasonHint": "Минимум 10 символов. Попадёт в журнал аудита и в комментарий к записи о кофе.",
    "cancelDone": "Приглашение отменено",
    "cancelUnavailable": "Приглашение в этом состоянии не отменяется. Спор решается в окне жалобы."
  },
  "ledger": {
    "title": "Учёт (ledger)",
    "subtitle": "Каждое движение кофе — неизменяемая запись. Единственный способ разобрать спор.",
    "user": "Пользователь",
    "account": "Счёт",
    "amount": "Кофе",
    "refType": "Основание",
    "refId": "Связанная запись",
    "createdAt": "Время",
    "empty": "Записи не найдены",
    "accounts": {
      "available": "Доступно",
      "held": "Заблокировано",
      "maturing": "Созревает",
      "external": "Внешний"
    },
    "balanceCheck": "Проверка суммы",
    "balanceCheckOk": "Сумма всех записей равна нулю",
    "balanceCheckFail": "Сумма проводок {{value}} — не ноль. Это системная ошибка.",
    "note": "Примечание",
    "inflow": "Приход",
    "outflow": "Расход",
    "netFlow": "Итого",
    "external": "Внешний",
    "externalHint": "Счёт без владельца: точка входа и выхода денег из системы.",
    "balanceOk": "Сумма равна нулю",
    "balanceBroken": "Сумма нарушена",
    "adjustTitle": "Корректировка кофе",
    "adjustHint": "Запись не удаляется — поверх кладётся новая. Причина остаётся в журнале.",
    "adjustDirection": "Направление",
    "adjust_add": "Добавить",
    "adjust_remove": "Списать",
    "adjustAmount": "Сколько кофе",
    "adjustAccount": "Какой счёт",
    "adjustPreview": "Баланс:",
    "adjustNegative": "Баланс уйдёт в минус. При возврате платежа это нормально, в остальных случаях проверьте.",
    "adjustNote": "Причина",
    "adjustNotePlaceholder": "Например: ручной возврат по спору #124, банковский документ 9912",
    "adjustNoteHint": "Минимум 10 символов. Через месяц ответ на вопрос «почему так сделали?» будет только в этой строке.",
    "adjustSubmit": "Скорректировать",
    "adjustDone": "Счёт скорректирован"
  },
  "payments": {
    "title": "Платежи",
    "subtitle": "Пополнения баланса через Payme и Click.",
    "provider": "Провайдер",
    "providerTxnId": "ID провайдера",
    "amount": "Сумма, сум",
    "coffees": "Кофе",
    "status": "Статус",
    "createdAt": "Время",
    "empty": "Платежи не найдены",
    "statuses": {
      "pending": "В обработке",
      "succeeded": "Успешно",
      "cancelled": "Отменён",
      "failed": "Не прошёл"
    },
    "paidAt": "Время оплаты",
    "succeededCount": "Успешно",
    "totalAmount": "Сумма"
  },
  "withdrawals": {
    "title": "Выводы",
    "subtitle": "Запросы на вывод кофе в деньги. Кофе списывается в момент запроса.",
    "amount": "Сумма, сум",
    "destination": "Карта",
    "processedAt": "Обработан",
    "createdAt": "Время",
    "empty": "Запросы не найдены",
    "statuses": {
      "pending": "В ожидании",
      "paid": "Выплачено",
      "rejected": "Отклонено"
    },
    "coffees": "Кофе",
    "requestedAt": "Время запроса",
    "note": "Примечание",
    "pendingCount": "В ожидании",
    "paidAmount": "Выплачено",
    "decide": "Решение",
    "decideTitle": "Решение по выплате",
    "decideHint": "Сделайте перевод через банк, затем отметьте здесь. При отклонении кофе вернётся ментору.",
    "gross": "Всего",
    "tax": "Налог ({{percent}}%)",
    "net": "На карту",
    "markPaid": "Выплачено",
    "markedPaid": "Выплата отмечена",
    "reject": "Отклонить",
    "rejected": "Выплата отклонена, кофе возвращено",
    "notePlaceholder": "Номер банковского документа или причина отказа",
    "noteHint": "При отклонении причина обязательна и видна пользователю.",
    "closedTitle": "Вывод закрыт (ADR 0025)",
    "closedBody": "Кофе не выводится в деньги: его только покупают на платформе и тратят на встречи. Новые заявки не создаются, и эта страница осталась лишь для СТАРЫХ заявок, ждущих решения. Когда они закроются, страница опустеет."
  },
  "reports": {
    "title": "Жалобы",
    "subtitle": "Обоснованная жалоба возвращает кофе гостю и влияет на профиль. После второй обоснованной жалобы пользователь блокируется.",
    "reporter": "Кто пожаловался",
    "target": "На кого",
    "reason": "Причина",
    "comment": "Комментарий",
    "status": "Статус",
    "createdAt": "Время",
    "empty": "Жалоб нет",
    "queueEmpty": "Очередь пуста — жалоб на рассмотрении нет.",
    "statuses": {
      "open": "Открыта",
      "reviewing": "На рассмотрении",
      "resolved": "Решена",
      "rejected": "Отклонена"
    },
    "resolve": "Отметить решённой",
    "reject": "Отметить необоснованной",
    "blockTarget": "Заблокировать профиль",
    "review": "Рассмотреть",
    "meeting": "Встреча",
    "meetingChat": "Переписка",
    "threadReporter": "Заявитель",
    "threadTarget": "Вторая сторона",
    "threadEmpty": "Вопрос ещё не задан.",
    "targetWarning": "Этот человек узнает о жалобе ТОЛЬКО после вашего сообщения.",
    "moderator": "Модерация",
    "party": "Пользователь",
    "ask": "Задать вопрос",
    "askPlaceholder": "Спросите, что произошло. Ответ повлияет на решение.",
    "chatEmpty": "По этой встрече переписки нет.",
    "alreadyResolved": "Решение принято — переписка и кнопки закрыты.",
    "confirmResolve": "Признать жалобу обоснованной?",
    "confirmReject": "Признать жалобу необоснованной?",
    "moneyToGuest": "{{coffees}} кофе вернётся гостю. Если это вторая обоснованная жалоба на человека — он будет заблокирован.",
    "moneyToHost": "Встреча считается состоявшейся: {{coffees}} кофе перейдёт наставнику.",
    "noMoney": "Решение не затрагивает счёт — кофе уже у владельца. Влияет только на профиль.",
    "notePlaceholder": "Что выяснилось? Комментарий виден только модераторам.",
    "coffeeCount": "{{count}} кофе",
    "minuteCount": "{{count}} мин",
    "formats": {
      "offline": "Вживую",
      "online": "Онлайн"
    },
    "reasons": {
      "no_show": "Не пришёл",
      "behavior": "Неподобающее поведение",
      "spam": "Реклама или спам",
      "fake_profile": "Фейковый профиль",
      "other": "Другая причина",
      "impersonation": "Выдаёт себя за другого"
    },
    "moneySplit": "Кофе распределяется: наставнику {{host}}, гостю {{guest}}.",
    "splitLabel": "Сколько кофе наставнику?",
    "splitPlaceholder": "Рассчитать по решению",
    "splitHint": "Если оставить пустым: при обоснованной жалобе всё гостю, при необоснованной — всё наставнику. В споре об опоздании долю вводите сами.",
    "splitInvalid": "Введите число от 0 до {{coffees}}.",
    "roomLog": "Журнал входов",
    "roomLogEmpty": "От вебхука LiveKit записей не пришло. Это НЕ значит «никто не заходил»: таблица участия выше берётся из собственной записи сервера, и в споре надёжный источник именно она.",
    "roomLogAfter": "через {{count}} мин после начала",
    "roomLogBefore": "за {{count}} мин до начала",
    "roomLogServer": "Сервер",
    "roomKinds": {
      "joined": "вошёл",
      "left": "вышел",
      "finished": "комната закрыта"
    },
    "notFound": "Жалоба не найдена",
    "notFoundHint": "Возможно, ссылка устарела. Вернитесь в очередь и выберите жалобу из списка.",
    "decision": "Решение",
    "decisionHint": "Решение необратимо: оно влияет на профиль и в спорной встрече переводит кофе.",
    "noteLabel": "Комментарий модератора",
    "resolveForbidden": "У вас нет права принимать решение — материалы доступны только для чтения.",
    "roomActivity": "Участие",
    "roomActivityEmpty": "Записей об участии нет.",
    "roomEntries": "Заходов: {{count}}",
    "roomTotal": "Всего в комнате: {{time}}",
    "roomOnline": "сейчас в комнате",
    "roomGuest": "Гость",
    "roomHost": "Хост",
    "roomSessionOpen": "не закрыт",
    "roomActivityHint": "Вход берётся из собственной записи сервера — виден даже если вебхук LiveKit не дошёл.",
    "roomLogTitle": "Внешний журнал (LiveKit)",
    "meetingCard": "Карточка встречи",
    "meetingEnds": "Окончание",
    "meetingConfirmed": "Подтверждена",
    "selfPartyHint": "Вы сторона этой жалобы — рассматривать собственный спор нельзя. Его должен решить другой модератор.",
    "redact": "Скрыть сообщение",
    "restore": "Вернуть сообщение",
    "redacted": "Скрыто модератором",
    "redactHint": "Текст перестанет быть виден сторонам. Здесь он сохраняется полностью — сообщение это доказательство в споре.",
    "redactConfirm": "Текст сообщения перестанет быть виден сторонам. Не удаляется: вы сможете прочитать его здесь и вернуть в любой момент.",
    "restoreConfirm": "Текст вернётся сторонам.",
    "redactReason": "Причина",
    "redactReasonPlaceholder": "Например: оскорбление и номер телефона",
    "redactReasonHint": "Минимум 10 символов. Попадёт в журнал аудита.",
    "redactDone": "Сообщение скрыто",
    "restoreDone": "Сообщение возвращено"
  },
  "hostApplications": {
    "title": "Заявки наставников",
    "subtitle": "Наставничество — не переключатель: каждый новый наставник проходит эту очередь.",
    "empty": "Заявок нет",
    "queueEmpty": "Очередь пуста — сейчас нечего рассматривать.",
    "review": "Рассмотреть",
    "statuses": {
      "pending": "В очереди",
      "approved": "Одобрена",
      "rejected": "Отклонена"
    },
    "banned": "Наставничество ограничено",
    "bannedHint": "Этот человек лишён права быть наставником. Одобрение заявки ничего не даст — сначала нужно снять ограничение.",
    "meetingCount": "{{count}} встреч",
    "about": "О себе",
    "links": "Ссылки",
    "reviewNote": "Комментарий администратора",
    "level": "Доверие",
    "levels": {
      "1": "1 — не проверен",
      "2": "2 — заявка одобрена",
      "3": "3 — личность подтверждена"
    },
    "meetings": "Встречи",
    "phone": "Телефон",
    "registered": "Регистрация: {{date}}",
    "verifiedTitle": "Личность подтверждена",
    "approve": "Одобрить",
    "reject": "Отклонить",
    "confirmApprove": "Одобрить заявку?",
    "confirmReject": "Отклонить заявку?",
    "approveHint": "Человек сможет включить режим наставника, уровень доверия поднимется до 2. Режим не включается автоматически — его включает сам человек.",
    "rejectHint": "Заявка возвращается, человек может подать новую. Комментарий он увидит.",
    "notePlaceholder": "Причина. Заявитель её прочитает.",
    "alreadyReviewed": "Решение принято: {{date}}",
    "verify": "Выдать знак",
    "unverify": "Снять знак",
    "verifyHint": "Знак — это гарантия платформы, что человек тот, за кого себя выдаёт. Рассказ в заявке можно выдумать; встречу без жалоб проверили гости.",
    "verifyTooEarly": "Ещё рано: рекомендуется минимум {{count}} подтверждённых встреч. Решение за вами.",
    "confirmVerify": "В профиле появится знак верификации, человек получит уведомление.",
    "confirmUnverify": "Знак будет снят. При сомнениях это мягче, чем блокировка.",
    "ban": "Лишить наставничества",
    "unban": "Снять ограничение",
    "banHint": "Это НЕ блокировка аккаунта, кофе не изымается: человек остаётся гостем и тратит свой баланс, он лишь не может вернуться в каталог.",
    "confirmBan": "Режим наставника выключится и не включится снова. Кофе и статус аккаунта не затрагиваются.",
    "confirmUnban": "Человек снова сможет стать наставником. Режим не включится автоматически.",
    "banNotePlaceholder": "Причина. Пользователь её прочитает.",
    "applicant": "Заявитель",
    "status": "Статус",
    "hostBan": "Ограничение",
    "submitted": "Отправлена",
    "notFound": "Заявка не найдена",
    "notFoundHint": "Ссылка устарела или заявка удалена. Вернитесь к списку и найдите её в очереди.",
    "applicationSection": "Заявка",
    "decisionSection": "Решение",
    "tier": "Категория",
    "tiers": {
      "community": "Сообщество",
      "partner": "Партнёр"
    },
    "tierHint": "Партнёр — наставник, которого платформа пригласила сама. Это ярлык, а не выплата: кофе никому не выводится в деньги, и к этому полю не привязана никакая платёжная логика.",
    "tierToPartner": "Сделать партнёром",
    "tierToCommunity": "Вернуть в сообщество",
    "confirmTierPartner": "В профиле появится ярлык «партнёр». На баланс и кофе это никак не влияет.",
    "confirmTierCommunity": "Ярлык будет снят. На баланс и кофе это никак не влияет."
  },
  "settings": {
    "title": "Настройки платформы",
    "subtitle": "Цена, сроки и лимиты хранятся в базе — для изменения деплой не нужен.",
    "dangerHint": "Эти значения влияют на весь продукт сразу. Изменение цены и комиссии не затрагивает уже отправленные приглашения: каждое из них замораживает свою сумму и условия отмены в момент отправки.",
    "readOnlyHint": "У вас только право просмотра. Для изменения нужно `settings.update`.",
    "loadFailed": "Настройки не загрузились",
    "loadFailedHint": "Сервер не ответил. Попробуйте ещё раз — если повторяется, проверьте логи бэкенда.",
    "retry": "Повторить",
    "groupMoney": "Деньги",
    "groupDeadlines": "Сроки",
    "groupCancel": "Отмена",
    "groupSchedule": "Расписание",
    "invitationTtl": "Срок ответа на приглашение",
    "invitationTtlHint": "Без ответа за это время приглашение отменяется, кофе возвращается гостю.",
    "payoutMaturity": "Срок созревания выплаты",
    "payoutMaturityHint": "Кофе со встречи открывается к выводу после этого срока. Если в это окно поступит жалоба, модератор может распределить кофе. Не должен быть длиннее окна жалоб.",
    "freeCancel": "Окно бесплатной отмены",
    "freeCancelHint": "Если до встречи осталось больше этого времени, гость отменяет без штрафа.",
    "lateRefund": "Возврат при поздней отмене",
    "lateRefundHint": "После окна гостю возвращается эта доля, остальное остаётся наставнику как компенсация.",
    "bookingHorizon": "Горизонт расписания",
    "bookingHorizonHint": "Слоты дальше этого срока в каталоге не показываются.",
    "minNotice": "Минимальный запас времени",
    "minNoticeHint": "Слот можно занять не позже чем за это время до начала.",
    "range": "{{min}}–{{max}}",
    "percent": "%",
    "hours": "ч",
    "days": "дн.",
    "errInteger": "Введите целое число",
    "errRange": "Должно быть в диапазоне {{min}}–{{max}}",
    "confirmTitle": "Изменение, влияющее на деньги",
    "confirmBody": "Цена и комиссия действуют на всю платформу сразу. Отправленные приглашения сохранят прежние значения.",
    "confirmLabel": "Сохранить",
    "saved": "Настройки сохранены",
    "buyPrice": "Цена покупки",
    "buyPriceHint": "Цена покупки 1 кофе. Эта сумма списывается с карты пользователя.",
    "sellPrice": "Цена вывода",
    "sellPriceHint": "Цена вывода 1 кофе. Эта сумма приходит на карту наставника. Разница между ценами — доход платформы.",
    "errSellAboveBuy": "Цена вывода не может быть выше цены покупки.",
    "groupChat": "Чат и модерация",
    "reminderHours": "Напоминание",
    "reminderHoursHint": "За сколько часов до встречи отправляется напоминание.",
    "chatOpens": "Открытие чата",
    "chatOpensHint": "За сколько часов до встречи открывается чат. Стороны не видят номеров друг друга — чат их единственный канал связи.",
    "chatCloses": "Закрытие чата",
    "chatClosesHint": "Через сколько часов после встречи чат закрывается. Переписка сохраняется.",
    "reportWindow": "Окно жалобы",
    "reportWindowHint": "Сколько часов после встречи можно оставить жалобу.",
    "errReportBeforePayout": "Окно жалоб не может быть короче срока созревания выплаты: появится промежуток, когда кофе заморожен, а жалобу подать нельзя.",
    "errStep": "Значение должно быть кратно {{step}}",
    "rangeStep": "{{min}}–{{max}}, шаг {{step}}"
  },
  "meetingOptions": {
    "title": "Варианты встреч",
    "subtitle": "Здесь вы решаете, какие форматы и длительности предлагает платформа.",
    "dangerHint": "Изменение вступает в силу СРАЗУ. Отключённый вариант остаётся виден на публичных страницах, но выбрать его нельзя; хост не может включить его в профиле; ожидающее приглашение хост ПРИНЯТЬ НЕ СМОЖЕТ — при отклонении или истечении срока кофе вернётся гостю. Уже согласованные встречи пройдут как обычно: договорённость и деньги в них связаны.",
    "loadFailed": "Не удалось загрузить варианты",
    "loadFailedHint": "Сервер не ответил. Попробуйте ещё раз — если повторится, проверьте логи backend.",
    "formats": "Форматы",
    "durations": "Длительности",
    "format": {
      "offline": "Офлайн",
      "online": "Онлайн"
    },
    "formatHint": {
      "offline": "Встреча лично. Место договаривается в чате.",
      "online": "Встреча по видеосвязи."
    },
    "disabled": "Отключено",
    "lastEnabled": "Последний включённый вариант — его нельзя отключить.",
    "note": "Причина отключения",
    "noteHint": "Этот текст появится на публичной странице. Оставьте пустым — покажется стандартный: «Этот вариант пока недоступен».",
    "notePlaceholder": "Например: онлайн-встречи приостановлены до 1 октября",
    "saveNote": "Сохранить",
    "saved": "Изменение сохранено",
    "add": "Добавить",
    "added": "Длительность добавлена",
    "addTitle": "Новая длительность",
    "addHint": "Длительность потом не меняется: к ней привязываются тарифы и приглашения. Ошибочную можно только отключить.",
    "minutesLabel": "Длительность, минут",
    "minutesHint": "От {{min}} до {{max}}.",
    "toggleDuration": "Встреча на {{minutes}} минут",
    "minutes": "{{count}} мин",
    "hours": "{{count}} ч",
    "remove": "Удалить",
    "removed": "Длительность удалена",
    "removeTitle": "Убрать длительность из списка",
    "removeHint": "Работает только для длительности, которая нигде не использована. Если есть тарифы или приглашения — её нельзя удалить, только отключить.",
    "err": {
      "integer": "Введите целое число.",
      "range": "Значение вне допустимых границ.",
      "duplicate": "Такая длительность уже есть.",
      "coffeeRange": "Введите число от {{min}} до {{max}}."
    },
    "limitsTitle": "Границы предложения",
    "limitsHint": "Отдельно для каждого формата: у офлайн-встречи есть дорога и место. Это НИЖНЯЯ граница — ведущий может поставить выше. В онлайн-формате более длинная встреча не должна дешеветь в пересчёте на минуту: минимум для 30 минут вдвое больше, чем для 15.",
    "minCoffeesLabel": "Минимум кофе",
    "coffees": "кофе",
    "coffeesFrom": "кофе и больше",
    "limitAria": "{{duration}}, {{format}}: {{field}}",
    "limitAriaNew": "{{format}}: {{field}}"
  },
  "table": {
    "rowsPerPage": "На странице",
    "of": "/",
    "page": "Страница",
    "first": "Первая",
    "previous": "Предыдущая",
    "next": "Следующая",
    "last": "Последняя",
    "noResults": "Нет результатов",
    "columns": "Столбцы",
    "total": "Всего: {{count}}",
    "sort": "Сортировка",
    "sortAsc": "По возрастанию",
    "sortDesc": "По убыванию",
    "onThisPage": "На этой странице",
    "clearFilters": "Сбросить фильтры",
    "records": "{{count}} записей",
    "loadFailed": "Список не загрузился",
    "loadFailedHint": "Сервер не ответил. Обновите страницу или попробуйте позже.",
    "emptyFiltered": "Снимите фильтр — подходящих записей не найдено."
  },
  "errors": {
    "BELOW_HOST_MINIMUM": "Меньше минимального тарифа наставника.",
    "BROADCAST_NOT_LIVE": "Эфир сейчас не идёт.",
    "BROADCAST_NOT_READY": "Не удалось начать эфир: не указана ссылка для просмотра или эфир не опубликован.",
    "CANCELLATION_WINDOW_CLOSED": "Встреча началась — отменить нельзя.",
    "CHAT_CLOSED": "Чат закрыт.",
    "CHAT_NOT_AVAILABLE": "Для этого приглашения чата нет.",
    "CONFIRMATION_ALREADY_USED": "Этот код уже использован.",
    "CONFIRMATION_CODE_EXPIRED": "Срок кода подтверждения истёк.",
    "CONFIRMATION_CODE_INVALID": "Код подтверждения неверный.",
    "CONFIRMATION_LOCKED": "Превышено число неверных попыток — ввод кода временно закрыт.",
    "CONFIRMATION_NOT_APPLICABLE": "Онлайн-встреча не подтверждается кодом — система закрывает её сама по журналу входов.",
    "CONFIRMATION_TOO_EARLY": "Встреча ещё не началась.",
    "DISPUTE_CLOSED": "Обсуждение спора закрыто.",
    "DISPUTE_SELF_PARTY": "Вы сторона этой жалобы: рассматривать собственный спор нельзя.",
    "DUPLICATE_TRANSACTION": "Эта транзакция уже учтена.",
    "DURATION_DISABLED": "Эта длительность сейчас отключена.",
    "DURATION_NOT_OFFERED": "Наставник не проводит встречи такой длительности.",
    "FORBIDDEN": "Нет прав на это действие.",
    "FORMAT_DISABLED": "Этот формат сейчас отключён.",
    "FORMAT_NOT_OFFERED": "Наставник не предлагает этот формат.",
    "HOST_APPLICATION_ALREADY_REVIEWED": "Заявка уже рассмотрена — обновите страницу.",
    "HOST_APPLICATION_EXISTS": "У этого пользователя есть заявка на рассмотрении.",
    "HOST_APPLICATION_NOT_FOUND": "Заявка не найдена.",
    "HOST_APPLICATION_REQUIRED": "Сначала нужна заявка.",
    "HOST_BANNED": "Для этого пользователя режим наставника ограничен.",
    "HOST_UNAVAILABLE": "Наставник не принимает приглашения.",
    "INSUFFICIENT_BALANCE": "Недостаточно кофе: нужно {{required}}, есть {{available}}.",
    "INTERNAL_ERROR": "Ошибка на сервере. Скоро исправим.",
    "INVALID_STATE_TRANSITION": "Действие недоступно в текущем состоянии. Обновите страницу.",
    "INVITATION_ALREADY_SENT": "Приглашение на это время уже отправлено.",
    "INVITATION_NOT_FOUND": "Приглашение не найдено.",
    "INVITE_CODE_REQUIRED": "Закрытая бета: для отправки приглашения нужен код.",
    "LEDGER_IMBALANCE": "Расхождение в учёте. Это системная ошибка — проверьте немедленно.",
    "NETWORK_ERROR": "Не удалось связаться с сервером. Проверьте соединение.",
    "NOT_A_SPEAKER": "Этот человек не спикер эфира.",
    "NOT_FOUND": "Запрошенные данные не найдены.",
    "NO_AVAILABILITY_CONFIGURED": "Наставник не задал расписание.",
    "PAYLOAD_TOO_LARGE": "Файл слишком большой.",
    "PAYMENT_FAILED": "Платёж не прошёл.",
    "PAYMENT_PROVIDER_DISABLED": "Платёжная система временно недоступна. Попробуйте чуть позже.",
    "PAYOUT_PROFILE_LOCKED": "Подтверждённый профиль изменить нельзя.",
    "PAYOUT_PROFILE_REQUIRED": "Для вывода нужен подтверждённый налоговый профиль.",
    "PROFILE_INCOMPLETE": "Профиль заполнен не полностью.",
    "PROMO_BUDGET_EXHAUSTED": "Бонусный бюджет на этот месяц исчерпан. Его можно увеличить в настройках.",
    "PROMO_CODE_NOT_FOUND": "Такой промокод не найден.",
    "PROMO_CODE_UNAVAILABLE": "Код сейчас не работает: отключён, истёк или исчерпан.",
    "RATE_LIMITED": "Слишком много запросов. Немного подождите.",
    "REPORT_ALREADY_EXISTS": "По этой встрече уже есть жалоба.",
    "REPORT_ALREADY_RESOLVED": "Жалоба уже закрыта — обновите страницу.",
    "REPORT_NOT_ALLOWED": "На эту встречу нельзя подать жалобу.",
    "REPORT_NOT_FOUND": "Жалоба не найдена.",
    "REVIEW_ALREADY_EXISTS": "Оценка уже оставлена.",
    "REVIEW_NOT_ALLOWED": "Эту встречу нельзя оценить.",
    "ROOM_CLOSED": "Комната закрыта.",
    "ROOM_NOT_AVAILABLE": "У этой встречи нет онлайн-комнаты.",
    "ROOM_PARTICIPANT_PRESENT": "Собеседник уже в комнате.",
    "ROOM_SERVER_UNAVAILABLE": "Видеосервер сейчас не отвечает.",
    "SELF_INVITATION": "Нельзя отправить приглашение самому себе.",
    "SESSION_REVOKED": "Сессия закрыта. Войдите заново.",
    "SLOT_ALREADY_TAKEN": "Это время уже занято.",
    "SLOT_NOT_AVAILABLE": "Этого времени нет в расписании наставника.",
    "SPEAKER_NOT_HOST": "Спикером может быть только активный ментор.",
    "TELEGRAM_PHOTO_NOT_FOUND": "В Telegram не найдено фото профиля.",
    "TOKEN_EXPIRED": "Сессия истекла. Войдите заново.",
    "TOKEN_INVALID": "Сессия недействительна. Войдите заново.",
    "UNAUTHORIZED": "Требуется вход.",
    "UNKNOWN": "Произошла непредвиденная ошибка. Попробуйте ещё раз.",
    "USER_BLOCKED": "Пользователь заблокирован.",
    "USER_NOT_FOUND": "Пользователь не найден.",
    "VALIDATION_FAILED": "Данные неверны. Проверьте форму.",
    "WITHDRAWALS_DISABLED": "Кофе нельзя вывести деньгами. Его можно потратить только на встречи.",
    "WITHDRAWAL_BELOW_MINIMUM": "Сумма вывода меньше минимальной.",
    "WITHDRAWAL_NOT_PENDING": "Эта выплата уже обработана."
  },
  "notFound": {
    "title": "Страница не найдена",
    "body": "Ссылка устарела или адрес набран с ошибкой.",
    "cta": "На панель управления"
  },
  "errorPage": {
    "title": "Что-то пошло не так",
    "body": "Ошибка зафиксирована. Попробуйте обновить страницу.",
    "retry": "Попробовать снова",
    "staleTitle": "Панель обновилась",
    "staleBody": "Вы видите старую версию панели. Перезагрузите страницу — открытая работа не потеряется.",
    "staleRetry": "Перезагрузить страницу"
  },
  "roles": {
    "title": "Роли и права",
    "subtitle": "Роль — это имя для набора прав. Создавайте сколько угодно ролей: код не знает их названий, каждое действие проверяется по праву.",
    "create": "Создать роль",
    "createTitle": "Новая роль",
    "editTitle": "Редактирование роли",
    "formHint": "Отмечайте права по разделам или по одному. Список приходит с бэкенда и только читается.",
    "code": "Код",
    "codeHint": "Строчные буквы, цифры и _. После создания не меняется.",
    "name": "Название",
    "description": "Описание",
    "permissions": "Права",
    "selectedCount": "Выбрано: {{count}}",
    "permissionCount": "{{count}} прав",
    "system": "Системная роль",
    "empty": "Роли ещё не созданы",
    "emptyHint": "Создайте первую роль и назначьте её пользователям. Суперадмин имеет доступ ко всему и без роли.",
    "deleted": "Роль удалена",
    "deleteTitle": "Удалить роль?",
    "deleteHint": "Роль «{{name}}» будет удалена и снята со всех пользователей. Они сразу потеряют права, которые она давала.",
    "assigned": "Роли сохранены",
    "assignTitle": "Назначение ролей",
    "assignHint": "Выберите роли для {{name}}. Права будут объединением выбранных ролей.",
    "groups": {
      "dashboard": "Панель",
      "users": "Пользователи",
      "roles": "Роли",
      "hosts": "Наставники",
      "invitations": "Приглашения",
      "ledger": "Проводки",
      "payments": "Платежи",
      "reports": "Жалобы",
      "reference": "Справочники",
      "settings": "Настройки",
      "audit": "Журнал аудита",
      "analytics": "Аналитика",
      "sidebar": "Боковое меню"
    },
    "created": "Роль создана",
    "updated": "Роль сохранена",
    "notFound": "Роль не найдена",
    "notFoundHint": "Ссылка устарела или роль удалена. Вернитесь к списку и выберите её заново.",
    "readOnly": "Только просмотр: у вас нет права изменять эту роль.",
    "selectGroup": "Все права раздела «{{group}}»",
    "groupSelected": "{{selected}}/{{total}}",
    "expandAll": "Развернуть все",
    "collapseAll": "Свернуть все",
    "errors": {
      "nameMin": "Название — минимум 2 символа",
      "codeFormat": "Начинается со строчной буквы; буквы, цифры и _"
    }
  },
  "analytics": {
    "title": "Аналитика",
    "subtitle": "Визиты, страницы и воронка — из наших собственных данных. Яндекс Метрика в отдельной панели: она показывает «откуда пришли», эта страница — «что сделали».",
    "views": "Просмотры страниц",
    "visitors": "Уникальные посетители",
    "identified": "Авторизованные пользователи",
    "traffic": "Трафик по дням",
    "topPages": "Самые посещаемые страницы",
    "topReferrers": "Источники трафика",
    "events": "События",
    "empty": "За этот период данных нет",
    "emptyHint": "События начинают собираться при открытии сайта. Проверьте, заполнен ли NEXT_PUBLIC_ANALYTICS_URL во фронтенде.",
    "noReferrers": "Переходы без источника: адрес ввели вручную или ссылку прислали в мессенджере."
  },
  "reference": {
    "title": "Справочники",
    "subtitle": "Списки сфер, областей и районов. Изменения здесь сразу видны во всех формах и фильтрах сайта.",
    "create": {
      "industries": "Добавить сферу",
      "regions": "Добавить область",
      "districts": "Добавить район"
    },
    "editTitle": "Редактировать запись",
    "formHint": "Название нужно на всех трёх языках — иначе в этом языке покажется сам код.",
    "code": "Код",
    "codeHint": "Только строчные латинские буквы, цифры и дефис. После создания не меняется.",
    "name": {
      "uz": "Название (uz)",
      "ru": "Название (ru)",
      "en": "Название (en)"
    },
    "sortOrder": "Порядок",
    "status": "Статус",
    "active": "Активна",
    "inactive": "Отключена",
    "region": "Область",
    "regionHint": "После создания область не меняется.",
    "type": "Тип",
    "typeDistrict": "Район",
    "typeCity": "Город",
    "count": "{{count}} записей",
    "empty": "Список пуст",
    "emptyHint": "Добавьте первую запись.",
    "saved": "Сохранено",
    "titles": {
      "industries": "Сферы",
      "regions": "Области",
      "districts": "Районы"
    },
    "subtitles": {
      "industries": "Список сфер в форме профиля. Изменения сразу влияют на все формы и фильтры сайта.",
      "regions": "Список областей. К нему привязаны районы.",
      "districts": "Районы и города районного значения. Каждый относится к одной области."
    },
    "allRegions": "Все области",
    "loadFailed": "Список не загрузился",
    "loadFailedHint": "Сервер не ответил. Обновите страницу или попробуйте позже."
  },
  "activity": {
    "title": "Активность",
    "time": "Время",
    "action": "Действие",
    "actor": "Кто",
    "changes": "Изменения",
    "ip": "IP",
    "self": "Сам",
    "system": "Система",
    "more": "ещё {{count}}",
    "empty": "Пока нет записей активности"
  },
  "devices": {
    "title": "Устройства",
    "device": "Устройство",
    "startedAt": "Вход",
    "lastUsed": "Последняя активность",
    "revoke": "Завершить",
    "revoked": "Сессия завершена",
    "unknown": "Неизвестное устройство",
    "empty": "Активных сессий нет"
  },
  "audit": {
    "title": "Журнал аудита",
    "subtitle": "Кто, когда и что сделал — по всей платформе.",
    "empty": "Записи не найдены",
    "entity": "Объект",
    "from": "С даты",
    "to": "По дату",
    "actorRole": "Роль",
    "requestId": "ID запроса",
    "userAgent": "Устройство",
    "before": "До",
    "after": "После",
    "noPayload": "Данные не записаны"
  },
  "adminNotifications": {
    "title": "Очередь",
    "empty": "Новых сообщений нет. Здесь появляются дела из очереди: заявки, жалобы и движение денег.",
    "unread": "{{count}} новых",
    "markRead": "Отметить прочитанными",
    "clear": "Очистить",
    "sessionOnly": "Список живёт только в этой вкладке: после перезагрузки он очистится, а сама очередь останется на своей странице.",
    "types": {
      "host_application_submitted": "Новая заявка наставника",
      "report_submitted": "Новая жалоба",
      "withdrawal_created": "Заявка на вывод",
      "payment_succeeded": "Новый платёж"
    }
  },
  "promo": {
    "title": "Промокоды",
    "subtitle": "Бонусное кофе, коды приглашений и кампании. Когда ментор выводит бонусное кофе, платформа платит деньги — это маркетинговый расход.",
    "create": "Новый код",
    "createTitle": "Новый промокод",
    "createHint": "Код сохраняется заглавными буквами. Как его напишет человек — неважно.",
    "editTitle": "Изменить код",
    "editHint": "Сам код и количество кофе не меняются — это уже розданное обещание. Можно остановить кампанию или продлить срок.",
    "edit": "Изменить",
    "saved": "Сохранено",
    "created": "Код создан",
    "empty": "Кодов пока нет",
    "emptyHint": "Создайте первый код и раздайте его через менторов.",
    "loadFailed": "Список не загрузился",
    "loadFailedHint": "Попробуйте обновить страницу.",
    "coffees": "{{count}} кофе",
    "noCoffees": "Без кофе",
    "noDeadline": "Без срока",
    "usedUnlimited": "{{used}} раз",
    "columns": {
      "code": "Код",
      "coffees": "Даёт",
      "uses": "Использован",
      "endsAt": "Истекает",
      "state": "Состояние"
    },
    "kind": {
      "invite": "Приглашение"
    },
    "state": {
      "active": "Работает",
      "disabled": "Отключён",
      "exhausted": "Исчерпан",
      "expired": "Истёк"
    },
    "fields": {
      "code": "Код",
      "coffees": "Сколько кофе даёт",
      "coffeesHint": "0 — не даёт кофе. Для кода приглашения это нормально: он только открывает право.",
      "invite": "Код приглашения",
      "inviteHint": "Открывает право отправлять приглашения в закрытой бете.",
      "maxUses": "Всего использований",
      "maxUsesPlaceholder": "Пусто — без лимита",
      "endsAt": "До какого числа",
      "note": "Заметка",
      "notePlaceholder": "Какая кампания, кто просил",
      "enabled": "Работает",
      "enabledHint": "Если выключить, код перестанет приниматься сразу. Выданные бонусы останутся."
    }
  },
  "live": {
    "title": "Эфиры",
    "subtitle": "Qahvadosh Live: эфир транслируется на YouTube, вопросы и ответы остаются на сайте.",
    "create": "Новый эфир",
    "createTitle": "Новый эфир",
    "editTitle": "Редактирование эфира",
    "formHint": "Эфир сохраняется как ЧЕРНОВИК — до публикации его никто не видит.",
    "empty": "Эфиров пока нет.",
    "loadFailed": "Не удалось загрузить список эфиров.",
    "fieldTitle": "Заголовок",
    "fieldDescription": "Описание",
    "fieldScheduledAt": "Время",
    "fieldSlug": "Ссылка",
    "slugPlaceholder": "будет создана из заголовка",
    "slugHint": "Оставьте пустым — создадим из заголовка. Если занята, добавим номер.",
    "slugLocked": "Ссылка опубликованного эфира не меняется — она уже могла разойтись.",
    "fieldWatchUrl": "Ссылка для просмотра",
    "watchUrlHint": "Ссылка на YouTube. ОБЯЗАТЕЛЬНА для запуска — без неё на странице не будет плеера.",
    "fieldSpeakers": "Спикеры",
    "addSpeaker": "Добавить спикера",
    "removeSpeaker": "Убрать спикера",
    "rolePlaceholder": "Роль",
    "noSpeakers": "Активных менторов нет. Спикером может быть только ментор.",
    "publish": "Опубликовать",
    "cancel": "Отменить",
    "start": "Начать",
    "stop": "Завершить",
    "startBlocked": "Для запуска нужна ссылка для просмотра.",
    "rtmpLabel": "RTMP-адреса",
    "rtmpPlaceholder": "rtmp://... (необязательно)",
    "started": "Эфир начался, уведомления отправлены",
    "stopped": "Эфир завершён",
    "startFailed": "Не удалось начать эфир",
    "stopFailed": "Не удалось завершить эфир",
    "statusChanged": "Статус изменён",
    "statusFailed": "Не удалось изменить статус",
    "created": "Эфир создан",
    "updated": "Эфир сохранён",
    "saveFailed": "Не удалось сохранить эфир",
    "reminderCount": "{{count}} напоминаний",
    "questionCount": "{{count}} вопросов",
    "questionsTitle": "Вопросы",
    "noQuestions": "Вопросов пока нет.",
    "markAnswered": "Ответили",
    "hide": "Скрыть",
    "unhide": "Вернуть",
    "questionFailed": "Не удалось изменить статус вопроса",
    "statusAnswered": "Ответили",
    "statusHidden": "Скрыт",
    "status": {
      "draft": "Черновик",
      "scheduled": "Опубликован",
      "live": "В эфире",
      "ended": "Завершён",
      "canceled": "Отменён"
    }
  },
  "payouts": {
    "title": "Профили для выплат",
    "subtitle": "Перед выводом ментор подтверждает, кто он и какой у него налоговый статус. После подтверждения вывод открывается.",
    "tabs": {
      "pending": "В очереди",
      "approved": "Подтверждённые",
      "rejected": "Отклонённые"
    },
    "status": {
      "individual": "Физлицо",
      "sole_trader": "ИП",
      "legal_entity": "Юрлицо"
    },
    "empty": {
      "pending": "Очередь пуста",
      "approved": "Подтверждённых профилей нет",
      "rejected": "Отклонённых профилей нет"
    },
    "account": "Аккаунт: {{name}}",
    "pinfl": "ПИНФЛ •••• {{last4}}",
    "noPinfl": "ПИНФЛ не указан",
    "tin": "ИНН {{tin}}",
    "review": "Рассмотреть",
    "reviewTitle": "Решение по профилю",
    "effect": {
      "individual": "{{name}} — физлицо. После подтверждения вывод откроется, и с каждой выплаты будет удерживаться налог на доход.",
      "sole_trader": "{{name}} — ИП. После подтверждения вывод откроется, и переводиться будет ПОЛНАЯ сумма.",
      "legal_entity": "{{name}} — юрлицо. После подтверждения вывод откроется, и переводиться будет ПОЛНАЯ сумма."
    },
    "fields": {
      "account": "Аккаунт",
      "fullName": "ФИО",
      "pinfl": "ПИНФЛ",
      "tin": "ИНН",
      "note": "Комментарий"
    },
    "notePlaceholder": "При отклонении причина обязательна",
    "noteHint": "Причина отклонения видна пользователю — напишите, что исправить.",
    "approve": "Подтвердить",
    "reject": "Отклонить",
    "approved": "Профиль подтверждён",
    "rejected": "Профиль отклонён",
    "closedTitle": "Новые профили не принимаются (ADR 0025)",
    "closedBody": "Вывод закрыт, поэтому налоговый профиль больше не нужен: отправить новый нельзя. Существующие записи остаются как история модерации, ПИНФЛ очищен миграцией."
  },
  "reviews": {
    "title": "Отзывы",
    "subtitle": "Комментарии после встреч. Отзыв, нарушающий правила, скрывается — не удаляется.",
    "search": "Поиск",
    "searchPlaceholder": "Текст отзыва или имя",
    "filter": "Состояние",
    "filterAll": "Все",
    "filterVisible": "Видимые",
    "filterHidden": "Скрытые",
    "empty": "Отзывы не найдены",
    "emptyHint": "Расширьте фильтр или измените запрос.",
    "isHidden": "Скрыт",
    "hiddenBecause": "Причина: {{reason}}",
    "hide": "Скрыть",
    "show": "Вернуть",
    "hidden": "Отзыв скрыт",
    "shown": "Отзыв возвращён",
    "hideConfirm": "Отзыв исчезнет с публичной страницы и выйдет из рейтинга наставника. Не удаляется — можно вернуть в любой момент.",
    "showConfirm": "Отзыв вернётся на публичную страницу и снова войдёт в рейтинг.",
    "reason": "Причина",
    "reasonPlaceholder": "Например: оскорбление, не относится к встрече",
    "reasonHint": "Минимум 10 символов. Попадёт в журнал аудита и будет видна рядом с отзывом."
  },
  "messages": {
    "title": "Сообщения и объявления",
    "subtitle": "Напишите пользователю или дайте объявление всем. Сообщение видно на сайте и в Telegram.",
    "announceTitle": "Новое объявление",
    "audience": "Кому",
    "audienceAll": "Всем",
    "audienceHosts": "Только наставникам",
    "text": "Текст",
    "textPlaceholder": "Например: 20 сентября с 02:00 до 04:00 сайт будет недоступен.",
    "textHint": "Текст НЕ ПЕРЕВОДИТСЯ — пользователь увидит его ровно таким. Минимум 10, максимум 1000 символов.",
    "send": "Отправить",
    "confirmTitle": "Отправить объявление",
    "confirmHint": "Сообщение уйдёт на тысячи телефонов, и ОТМЕНИТЬ ЭТО НЕЛЬЗЯ. Прочтите текст ещё раз.",
    "announceDone": "Отправлено {{count}} пользователям",
    "filterAll": "Все",
    "filterAnnouncements": "Объявления",
    "filterPersonal": "Личные",
    "types": {
      "admin_message": "Личное",
      "admin_announcement": "Объявление"
    },
    "reach": "Прочитали {{read}} из {{total}}",
    "empty": "Сообщений пока нет",
    "emptyHint": "Дайте объявление в форме выше или напишите лично из карточки пользователя.",
    "emptyHintRead": "Отправленные сообщения появятся здесь.",
    "toUser": "Написать",
    "toUserHint": "Сообщение попадёт в уведомления на сайте и (если подключён Telegram) в бота.",
    "toUserDone": "Сообщение отправлено"
  }
}
